module.exports = __webpack_public_path__ + "static/media/networth.4296e70e.png";